import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/labels/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/labels/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/labels/updateById', data)
}

// 列表查询
export function list (data) {
  return request.post('/business/labels/list', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/labels/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/labels/delete/batch', {
    params: {
      ids
    }
  })
}
